import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { MailboxInfo } from 'owa-client-ids';
import { isConnectedAccount } from 'owa-accounts-store';
import { isMeetingOnCalendarSharedWithMe } from 'owa-calendar-event-capabilities';

// Used to determine if the event is being created from a group calendar, delegate calendar or
// a connected account.
export function isEventFromDifferentMailbox(event: CalendarEvent) {
    if (isMeetingOnCalendarSharedWithMe(event)) {
        return true;
    }

    const eventMailboxInfo: MailboxInfo = event.ParentFolderId?.mailboxInfo;
    if (
        eventMailboxInfo?.mailboxSmtpAddress &&
        isConnectedAccount(eventMailboxInfo.mailboxSmtpAddress)
    ) {
        return true;
    }

    return false;
}
